import React, { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import RefreshIcon from "@mui/icons-material/Refresh";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Header from "./../Header";
import { getData } from "../../services/library";
import Navbar from "../Navbar";
import AllRemitosTable from "./components/AllRemitosTable";
import { getUserBranchesFilter } from "../../utils/filters";
import * as apiRemitos from "./api"

const BRAND = {
  main: "#2471A3",
  dark: "#1B4F72",
  light: "#EAF2F8",
  accent: "#F39C12",
  surface: "#F4F7F9",
  border: "#E1E8ED",
};

function Remitos() {
  const [remitos, setRemitos] = useState();

  useEffect(() => {
    const sucursales = getUserBranchesFilter();
    getData(`/remitos/by-suc?sucursales=${encodeURIComponent(sucursales)}`, setRemitos);
    // apiRemitos.getRemitos(setRemitos)
  }, []);

  return (
    <div>
      <Navbar />
      <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
        <Container
          maxWidth={false}
          sx={{ py: { xs: 1, md: 2 }, px: { xs: 2, md: 4 } }}
        >
          <Header 
            title="REMITOS"
            subtitle="Consulta de remitos cargados."
            BRAND={BRAND}
          />
          {remitos && <AllRemitosTable remitos={remitos} setRemitos={setRemitos}/>}
        </Container>
      </Box>
    </div>
  );
}

export default Remitos;
